import app from 'flarum/forum/app';
export default class WebsocketUpdates {
  /** In arrival order, which breaks ties between activity in the same second. */
  discussions = (() => new Map())();
  onTimerCallback = null;
  seconds = 0;
  length() {
    return this.discussions.size;
  }
  push(discussion) {
    this.discussions.set(discussion.id(), discussion);
  }
  remove(discussion) {
    this.discussions.delete(discussion.id());
  }
  has(discussion) {
    return this.discussions.has(discussion.id());
  }
  isEmpty() {
    return this.length() === 0;
  }
  reset() {
    this.discussions.clear();
  }

  /**
   * Read when needed rather than at construction: the buffer is created at
   * boot, before the forum's attributes are loaded.
   */
  getReleaseInterval() {
    return app.forum.attribute('flarum-realtime.release-discussion-updates-interval');
  }

  /**
   * Releases new discussion updates to the discussion list.
   */
  release(state) {
    this.stopTimer();

    // Each one goes to the top of the list, so the oldest activity goes first
    // and the most recent ends up on top. `lastPostedAt` is only precise to the
    // second; the sort is stable, so ties keep their arrival order.
    Array.from(this.discussions.values()).sort((a, b) => (a.lastPostedAt()?.getTime() ?? 0) - (b.lastPostedAt()?.getTime() ?? 0)).forEach(discussion => state.addDiscussion(discussion));

    // Reset new discussions array.
    this.reset();

    // Reset page count.
    app.setTitleCount(0);
  }

  /**
   * Starts the timer that will release new discussion updates to the discussion list.
   */
  startTimer() {
    if (this.autoRelease()) {
      this.stopTimer();
      this.seconds = this.getReleaseInterval();
      this.timer = window.setInterval(() => {
        this.seconds--;
        if (this.seconds < 0) return this.stopTimer();
        this.onTimerCallback && this.onTimerCallback(this.seconds);
      }, 1000);
    }
  }
  stopTimer() {
    clearInterval(this.timer);
    this.timer = undefined;
  }
  isTimerRunning() {
    return this.timer !== undefined;
  }
  onTimer(callback) {
    this.onTimerCallback = callback;
  }
  autoRelease() {
    return this.getReleaseInterval() > 0;
  }
}
flarum.reg.add('flarum-realtime', 'forum/extend/DiscussionList/WebsocketUpdates', WebsocketUpdates);